<template>
  <div class="content" :style="styleObject">
    <div class="security-box">
      <img class="logo-img" src="@/assets/images/login.png" />
      <div class="login-text" v-if="$store.getters.authorityRoute == '/parent'">
        Welcome to Online Application System
      </div>
      <div class="login-text" v-else>
        Welcome to Online Application System Admin Portal
      </div>
      <el-form
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        label-width="180px"
        :model="formLabelAlign"
      >
        <el-form-item label="已登記電郵 Registered Email:" prop="email">
          <el-input
            v-model="formLabelAlign.email"
            placeholder="Registered Email"
          >
            <template slot="prepend"><i class="el-icon-message"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item label="密碼 Password:" prop="password">
          <el-input
            show-password
            v-model="formLabelAlign.password"
            placeholder="Password"
          >
            <template slot="prepend"><i class="el-icon-lock"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onSignIn">登 入 Sign in</el-button>
        </el-form-item>
      </el-form>
      <div class="forgot-text cursor" @click="onForgotPassword">
        忘記密碼 Forgot Password
      </div>
      <template v-if="$store.getters.authorityRoute == '/parent'">
        <div
          class="forgot-text resendActivationCode-text cursor wordWrap"
          @click="onResendActivationCode"
        >
          重發啓動驗證碼 Resend Activation Code
        </div>
        <div
          class="forgot-text createAccount-text cursor"
          @click="onCreateAccount"
        >
          開設戶口 Create Account
        </div>
        <div class="forgot-text contactUs-text cursor" @click="onContactUs">
          聯絡我們 Contact Us
        </div>
        <div class="forgot-text contactUs-text cursor">
          請使用 Google Chrome 或 Microsoft Edge 填寫申請表
        </div>
        <div class="forgot-text contactUs-text cursor">
          Please fill out the application form using Google Chrome or Microsoft Edge.
        </div>
      </template>
      <copyrightInformation :styleObject="styleObjects"></copyrightInformation>
    </div>

    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import { login, getActiveUser } from "@/api/security";
import { setToken, setUserInfo } from "@/utils/auth";
import loadingDialog from "@/components/loadingDialog/index";
import copyrightInformation from "@/components/copyrightInformation/index";
import { getSetting } from "@/api/parent/setting";
export default {
  components: { loadingDialog,copyrightInformation },

  data() {
    return {
      styleObjects:{
        color: '#fff !important'
      },
      year: 2024,
      styleObject: {
        backgroundImage: "",
      },
      setting: {},
      centerDialogVisible: false,
      formLabelAlign: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "The Email cannot be empty  郵箱不能為空",
            trigger: "blur",
          },
          {
            type: "email",
            message: "郵箱格式不正確 The E-mail format is incorrect",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "The password cannot be empty  密碼不能為空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    setting: {
      handler(v) {
        if (v != null) {
          this.styleObject.backgroundImage = `url(${this.setting.backgroundImage1})`;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getSetting();
    if (this.$router.currentRoute.query.access_token != null) {
      this.getActiveUser();
    }
  },
  methods: {
    getActiveUser() {
      let from = {
        accessToken: this.$router.currentRoute.query.access_token,
      };
      getActiveUser(from).then(() => {
        //消息
        this.$message({
          message: "激活成功。Activation successful.",
          type: "success",
        });
      });
    },
    getSetting() {
      getSetting().then((v) => {
        this.setting = v.data;
      });
    },
    onContactUs() {
      window.open("https://www.logosacademy.edu.hk/", "_blank");
    },
    onCreateAccount() {
      this.$router.push({
        path: `${this.$store.getters.authorityRoute}/createAccount`,
      });
    },
    onResendActivationCode() {
      this.$router.push({
        path: `${this.$store.getters.authorityRoute}/resendActivationCode`,
      });
    },
    onForgotPassword() {
      this.$router.push({
        path: `${this.$store.getters.authorityRoute}/forgetPassword`,
      });
    },
    onSignIn() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    login() {
      this.centerDialogVisible = true;
      let form = {
        email: this.formLabelAlign.email.trim(),
        password: this.formLabelAlign.password.trim(),
      };
      login(form)
        .then((v) => {
          setToken(this.$store.getters.authorityRoute, v.data.accessToken);
          setUserInfo(`userInfo/${this.$store.getters.authorityRoute}`, v.data);
          if (v.data.roleName == "applicant") {
            this.$router.push("/parent/home");
          } else {
            this.$router.push("/admin/userAccountSetting");
          }
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100% !important;
  background-color: #070060;
  background-image: url("~@/assets/images/bg.png");
  background-size: 100%;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
}
.security-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  height: 100% !important;
}
.el-form {
  width: 18.75rem;
  display: block;
}
.el-form-item {
  color: #fff !important;
}
.login-text {
  color: #fff;
  font-size: 2.5rem;
  margin-top: 1.25rem;
  margin-bottom: 1.875rem;
}
.reserved-text {
  color: #fff !important;
}
.forgot-text {
  color: #2eac00;
  text-align: center;
  font-weight: bold;
  font-size: 1.25rem;
  margin-bottom: 0.8125rem;
}
.resendActivationCode-text {
  color: #72acff;
}
.createAccount-text {
  color: #ff7272;
}
.contactUs-text {
  color: #fff;
}
::v-deep {
  .el-form--label-top .el-form-item__label {
    color: #fff !important;
  }
  .el-button--info {
    width: 100%;
    background-color: #337ab7;
    border-color: #337ab7;
  }

}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .content,
  .security-box {
    height: 100vh !important;
  }
  .login-text {
    font-size: 1rem;
  }
  .reserved-text {
    //取消定位
    position: relative;
    text-align: center;
    margin-top: 0.625rem;
  }
  .forgot-text {
    font-size: 1.125rem;
  }
}
</style>